export type CurrentUserProfile = {
  id: number;
  name: string | null;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  title: string | null;
  phone: string | null;
  timezone: string | null;
  status: string | null;
  avatar_url: string | null;
  has_local_photo: boolean;
  sso_provider: string | null;
  companies: Array<{
    id: number;
    name: string;
    slug: string;
    status: string;
  }>;
};

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';

const readJson = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    const message = response.status === 422 ? 'Please check the profile fields and try again.' : `Profile request failed (${response.status}).`;
    throw new Error(message);
  }

  return response.json() as Promise<T>;
};

export const fetchCurrentUserProfile = async (): Promise<CurrentUserProfile> => {
  const payload = await readJson<{ profile: CurrentUserProfile }>(
    await fetch('/api/v1/secure/profile', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
  );

  return payload.profile;
};

export const saveCurrentUserProfile = async (formData: FormData): Promise<CurrentUserProfile> => {
  const payload = await readJson<{ profile: CurrentUserProfile }>(
    await fetch('/api/v1/secure/profile', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-CSRF-TOKEN': csrfToken,
      },
      body: formData,
    })
  );

  window.__CARES_BOOTSTRAP__ = {
    ...(window.__CARES_BOOTSTRAP__ ?? {
      authenticated: true,
      user: null,
      canAccessAdmin: false,
      navigation: {
        mySchedule: true,
        schedulerReview: false,
        scheduleSettings: false,
        admin: false,
        companyProvisioning: false,
      },
      clientShellCompanies: [],
      tenantCompanies: [],
    }),
    user: {
      name: payload.profile.name ?? '',
      email: payload.profile.email ?? '',
      status: payload.profile.status ?? '',
      avatar_url: payload.profile.avatar_url,
    },
  };
  window.dispatchEvent(new CustomEvent('cares:bootstrap-updated'));

  return payload.profile;
};
